"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _functions = require("../../../utils/functions");

var _lodash = _interopRequireDefault(require("lodash"));

var _tableModule = _interopRequireDefault(require("./table.module.css"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _link = _interopRequireDefault(require("../link/link"));

var _button = _interopRequireDefault(require("../button/button"));

var _table = _interopRequireDefault(require("./table"));

var _loader = _interopRequireDefault(require("../loader/loader"));

var _constants = require("../../../utils/constants");

var _hrefLink = _interopRequireDefault(require("../hrefLink/hrefLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ActionsCell = function ActionsCell(_ref) {
  var actions = _ref.actions,
      datum = _ref.datum,
      rowIndex = _ref.rowIndex,
      id = _ref.id;
  return _react.default.createElement("td", {
    id: rowIndex ? rowIndex : null
  }, actions.map(function (action, index) {
    if (action.customComponent) {
      var Comp = action.customComponent;
      return _react.default.createElement(Comp, {
        id: rowIndex ? "".concat(rowIndex, "_custom_action") : null,
        key: index,
        datum: datum,
        action: action,
        rowIndex: rowIndex
      });
    } else if (action.isActionLink) {
      var to = action.callback(datum, rowIndex);
      return _react.default.createElement("div", {
        id: action.id ? "".concat(action.id, "_table_item_").concat(index, "_link_wrapper") : null,
        key: index
      }, _react.default.createElement(_hrefLink.default, {
        id: id ? "".concat(id, "_table_item_").concat(index, "_link_") : null,
        key: index,
        to: to,
        label: action.label,
        arrowDirection: action.arrowDirection,
        reversedArrow: action.reversedArrow
      }));
    }

    return _react.default.createElement("div", {
      id: id ? "".concat(id, "_table_item_").concat(index, "_link_wrapper") : null,
      key: index
    }, _react.default.createElement(_link.default, {
      id: id ? "".concat(id, "_table_item_").concat(index, "_link") : null,
      disabled: action.isDisabled ? action.isDisabled(datum) : false,
      onClick: function onClick() {
        return action.callback(datum, rowIndex);
      },
      arrowDirection: "left",
      variant: "tertiary",
      label: action.label
    }));
  }));
};

var TableList = function TableList(props) {
  var id = props.id,
      selectable = props.selectable,
      responsive = props.responsive,
      striped = props.striped,
      columns = props.columns,
      onSortedChange = props.onSortedChange,
      onSelectAll = props.onSelectAll,
      selected = props.selected,
      onDatumSelect = props.onDatumSelect,
      data = props.data,
      orderBy = props.orderBy,
      orderAsc = props.orderAsc,
      hasActions = props.hasActions,
      actions = props.actions,
      expandableRow = props.expandableRow,
      onTableRowExpand = props.onTableRowExpand,
      expandedTableRows = props.expandedTableRows,
      totalColumns = props.totalColumns,
      nestedTableTitle = props.nestedTableTitle,
      tableHover = props.tableHover,
      customNestedTableComponent = props.customNestedTableComponent,
      actionOnLeft = props.actionOnLeft,
      withVerticalAlignedHeader = props.withVerticalAlignedHeader,
      loadingRows = props.loadingRows,
      onRowStyleChange = props.onRowStyleChange,
      noResultsMessage = props.noResultsMessage,
      sections = props.sections,
      loadingTableList = props.loadingTableList,
      selectableRowDisabled = props.selectableRowDisabled,
      isIndented = props.isIndented,
      headerVariant = props.headerVariant,
      _props$selectedRowSty = props.selectedRowStyle,
      selectedRowStyle = _props$selectedRowSty === void 0 ? _constants.primaryVariantStyle : _props$selectedRowSty;

  var calculateNestedTableTitleLength = function calculateNestedTableTitleLength() {
    return columns.filter(function (x) {
      return x.hidden !== true;
    }).length + (selectable ? 1 : 0) + (expandableRow ? 1 : 0);
  };

  if (loadingTableList) {
    return _react.default.createElement(_loader.default, {
      id: id ? "".concat(id, "_table_loader") : null,
      variant: "list"
    });
  }

  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, responsive ? _tableModule.default["table-responsive"] : "", isIndented ? _tableModule.default["table-indented"] : "")
  }, _react.default.createElement("table", {
    id: id ? "".concat(id, "_table_list") : null,
    className: (0, _classnames.default)(_tableModule.default["table"], striped ? _tableModule.default["table-striped"] : "", selectable ? _tableModule.default["table-selectable"] : "", tableHover ? _tableModule.default["table-hover"] : "", withVerticalAlignedHeader ? _tableModule.default["table-vertical-aligned-header"] : "")
  }, _react.default.createElement("thead", {
    id: id ? "".concat(id, "_table_head") : null,
    className: (0, _classnames.default)(headerVariant === "tertiary" ? _tableModule.default["tertiary"] : "")
  }, nestedTableTitle && _react.default.createElement("tr", {
    id: id ? "".concat(id, "_table_head_tr_title") : null,
    className: _tableModule.default["secondary-table-header"]
  }, _react.default.createElement("th", {
    id: id ? "".concat(id, "_table_head_th_title") : null,
    colSpan: calculateNestedTableTitleLength()
  }, nestedTableTitle)), _react.default.createElement("tr", {
    id: id ? "".concat(id, "_table_head_tr_expandable_row") : null
  }, expandableRow && _react.default.createElement("th", {
    id: id ? "".concat(id, "_table_head_th_expandable_row") : null,
    width: "10px"
  }), selectable && _react.default.createElement("th", {
    id: id ? "".concat(id, "_table_head_th_selectable") : null,
    className: (0, _classnames.default)(_tableModule.default["control-checkbox"])
  }, onSelectAll && _react.default.createElement("input", {
    id: id ? "".concat(id, "_table_head_th_selectable_input") : null,
    type: "checkbox",
    checked: data.filter(function (d) {
      return selectableRowDisabled ? selectableRowDisabled(d) === false : true;
    }).length === _lodash.default.size(selected) && data.filter(function (d) {
      return selectableRowDisabled ? selectableRowDisabled(d) === false : true;
    }).length > 0,
    onChange: function onChange(evt) {
      return onSelectAll(evt.target.checked);
    }
  })), hasActions && actionOnLeft && _react.default.createElement("th", {
    id: id ? "".concat(id, "_table_head_th_actions") : null
  }, "Actions"), columns.filter(function (x) {
    return x.hidden !== true;
  }).map(function (column) {
    return _react.default.createElement("th", {
      id: id ? "".concat(id, "_table_column_").concat(column.id) : null,
      key: column.propertyName,
      className: (0, _classnames.default)(column.sortable ? _tableModule.default["sortable"] : "", _tableModule.default[(0, _functions.getSortableColumnSortClass)(orderBy, orderAsc, column.id)]),
      style: column.style ? column.style : null,
      onClick: column.sortable ? function () {
        return onSortedChange(column.id);
      } : null
    }, column.header, column.sortable && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", {
      id: id ? "".concat(id, "_table_column_").concat(column.id, "_arrow_up") : null,
      style: column.sortingStyle ? column.sortingStyle : null,
      className: (0, _classnames.default)(_tableModule.default["glyphicon"], _tableModule.default["glyphicon-arrow-up"])
    }), _react.default.createElement("span", {
      id: id ? "".concat(id, "_table_column_").concat(column.id, "_arrow_down") : null,
      className: (0, _classnames.default)(_tableModule.default["glyphicon"], _tableModule.default["glyphicon-arrow-down"]),
      style: column.sortingStyle ? column.sortingStyle : null
    })));
  }), hasActions && !actionOnLeft && _react.default.createElement("th", {
    id: id ? "".concat(id, "_table_head_th_actions") : null
  }, "Actions"))), _react.default.createElement("tbody", {
    id: id ? "".concat(id, "_table_body") : null
  }, sections && sections.length > 0 && sections.map(function (section) {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("tr", {
      id: id ? "".concat(id, "_table_sub_head_tr_title") : null,
      className: _tableModule.default["nested-table-header"]
    }, _react.default.createElement("th", {
      id: id ? "".concat(id, "_table_sub_head_th_title") : null,
      colSpan: columns.length
    }, section.formatter ? section.formatter() : section.header)), data.map(function (datum, index) {
      return datum.sectionPropertyName === section.propertyName && _react.default.createElement("tr", {
        id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_tr") : null,
        style: onRowStyleChange ? onRowStyleChange(datum) : {},
        key: index
      }, columns.filter(function (x) {
        return x.hidden !== true;
      }).map(function (column) {
        return _react.default.createElement("td", {
          id: id ? "".concat(id, "_table_column_").concat(column.id, "_td") : null,
          key: column.propertyName
        }, column.formatter ? column.formatter(datum) : _lodash.default.get(datum, column.propertyName));
      }));
    }));
  }), data && data.length === 0 && noResultsMessage ? _react.default.createElement("tr", null, _react.default.createElement("td", {
    className: _tableModule.default["no-result-message"],
    colSpan: "".concat(columns.length + 2)
  }, noResultsMessage)) : (!sections || sections.length === 0) && data.map(function (datum, index) {
    return _react.default.createElement(TableListRow, {
      key: datum.id ? datum.id : index,
      customNestedTableComponent: customNestedTableComponent,
      expandableRow: expandableRow,
      index: index,
      datum: datum,
      id: id,
      onRowStyleChange: onRowStyleChange,
      selectable: selectable,
      loadingRows: loadingRows,
      totalColumns: totalColumns,
      expandedTableRows: expandedTableRows,
      onDatumSelect: onDatumSelect,
      hasActions: hasActions,
      actionOnLeft: actionOnLeft,
      actions: actions,
      columns: columns,
      selected: selected,
      onTableRowExpand: onTableRowExpand,
      selectableRowDisabled: selectableRowDisabled,
      selectedRowStyle: selectedRowStyle
    });
  }))));
};

var TableListRow = function TableListRow(props) {
  var _classNames;

  var customNestedTableComponent = props.customNestedTableComponent,
      expandableRow = props.expandableRow,
      index = props.index,
      datum = props.datum,
      id = props.id,
      onRowStyleChange = props.onRowStyleChange,
      selectable = props.selectable,
      loadingRows = props.loadingRows,
      totalColumns = props.totalColumns,
      expandedTableRows = props.expandedTableRows,
      onDatumSelect = props.onDatumSelect,
      hasActions = props.hasActions,
      actionOnLeft = props.actionOnLeft,
      actions = props.actions,
      columns = props.columns,
      selected = props.selected,
      onTableRowExpand = props.onTableRowExpand,
      selectableRowDisabled = props.selectableRowDisabled,
      selectedRowStyle = props.selectedRowStyle;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("tr", {
    id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_tr") : null,
    style: onRowStyleChange ? onRowStyleChange(datum) : {},
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, _tableModule.default['row-selected'], selectable && selected[index] && selectedRowStyle === _constants.primaryVariantStyle), _defineProperty(_classNames, _tableModule.default['row-secondary-selected'], selectable && selected[index] && selectedRowStyle === _constants.secondaryVariantStyle), _classNames))
  }, loadingRows && loadingRows.length && loadingRows.includes(index) ? _react.default.createElement("td", {
    id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_td_loader") : null,
    colSpan: totalColumns
  }, _react.default.createElement(_loader.default, {
    id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_loader") : null,
    variant: "row"
  })) : _react.default.createElement(_react.default.Fragment, null, expandableRow && expandedTableRows && _react.default.createElement("td", {
    id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_button_wrapper") : null
  }, _react.default.createElement(_button.default, {
    id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_button") : null,
    variant: expandedTableRows.includes(index) ? "close" : "open",
    onClick: function onClick() {
      return onTableRowExpand(index, datum);
    }
  })), selectable && _react.default.createElement("td", {
    id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_td_selectable") : null,
    className: _tableModule.default["control-checkbox"]
  }, _react.default.createElement("input", {
    disabled: selectableRowDisabled && selectableRowDisabled(datum),
    id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_td_selectable_input") : null,
    type: "checkbox",
    name: "checkbox_".concat(index),
    checked: !!(selectable && selected[index]),
    onChange: function onChange(evt) {
      return onDatumSelect(evt.target.checked, index, datum);
    }
  })), hasActions && actionOnLeft && _react.default.createElement(ActionsCell, {
    actions: actions,
    datum: datum,
    rowIndex: index,
    id: id
  }), columns.filter(function (x) {
    return x.hidden !== true;
  }).map(function (column) {
    return _react.default.createElement("td", {
      id: id ? "".concat(id, "_table_column_").concat(column.id, "_td") : null,
      key: column.propertyName,
      className: "".concat(column.numberFormat ? _tableModule.default['number-format'] : "")
    }, column.formatter ? column.formatter(datum) : _lodash.default.get(datum, column.propertyName));
  }), hasActions && !actionOnLeft && _react.default.createElement(ActionsCell, {
    actions: actions,
    datum: datum,
    rowIndex: index,
    id: id
  }))), expandableRow && expandedTableRows.includes(index) && _react.default.createElement("tr", {
    id: id ? "".concat(id, "_table_expandable_row_tr") : null
  }, _react.default.createElement("td", {
    id: id ? "".concat(id, "_table_expandable_row_td") : null,
    colSpan: totalColumns
  }, customNestedTableComponent ? customNestedTableComponent({
    columns: expandableRow.columns,
    data: _lodash.default.get(datum, expandableRow.propertyNameWithData),
    previousRow: datum,
    previousRowIndex: index
  }) : _react.default.createElement(_table.default, _extends({
    id: id ? id : null,
    accordionItemHeaderFormatter: expandableRow.accordionItemHeaderFormatter,
    striped: true,
    tableHover: true,
    nestedTableTitle: expandableRow.nestedTableTitle,
    data: expandableRow.dataFormatter ? expandableRow.dataFormatter(_lodash.default.get(datum, expandableRow.propertyNameWithData)) : _lodash.default.get(datum, expandableRow.propertyNameWithData),
    columns: expandableRow.columns
  }, expandableRow.nestedTableProps)))));
};

TableList.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Array that contains the rows indexes that should have a loader */
  loadingRows: _propTypes.default.arrayOf(_propTypes.default.number),

  /** boolean indicating that the table should have a vertical aligned header */
  withVerticalAlignedHeader: _propTypes.default.bool,

  /** boolean indicating that when the table has actions they should appear on the left of the table */
  actionOnLeft: _propTypes.default.bool,

  /** The data that should be displayed. Can by an array of objects of any type and shape
   * NOTE: if your are using the prop sections you will need to add a property sectionPropertyName
   * in order to map the data to the sub titles */
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /** The columns of the list - table. The propertyName is used to match the desired property of the data objects.
   * eg: the data object {email : "user@test.io"} will be matched by the column: {propertyName: "email", header:
   * "Email!"}. If you wish to access nested properties from the data you should specify them again in the
   * propertyName separated with a dot "." eg: data: {user: {email : "user@test.io"}}, then the property name will be
   * propertyName: "user.email". The id property of is used for sorting. So it must match the correct sortBy key.
   * The formatter is a callback used to format the data as you wish. It is invoked with the datum. For example
   * formatting timestamp dates. the sortable prop specifies if the column is sortable
   * . The style property can be used to style the th as you want. The sorting style property can be used to
   * style the sorting arrows of the th as you want.*/
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    propertyName: _propTypes.default.string.isRequired,
    header: _propTypes.default.string.isRequired,
    id: _propTypes.default.string,
    formatter: _propTypes.default.func,
    sortable: _propTypes.default.bool,
    style: _propTypes.default.object,
    sortingStyle: _propTypes.default.object,
    hidden: _propTypes.default.bool
  })).isRequired,

  /** Boolean indicating that the items are selectable. If set to true, the props selected, onDatumSelect,*/
  selectable: _propTypes.default.bool,

  /** Object containing the selected items */
  selected: _propTypes.default.object,

  /** Callback invoked when select all input is clicked. It will be invoked with a checked bool property
   * eg: (allSelectedChecked) => {} */
  onSelectAll: _propTypes.default.func,

  /** Callback invoked to calculate if the row should not be taken into account for selecting.*/
  selectableRowDisabled: _propTypes.default.func,

  /** Callback invoked  when the use checks a row - item. It will be passed with the arguments: checked(bool),
   * index(number), datum(object), eg: (checked, index, datum) => {}*/
  onDatumSelect: _propTypes.default.func,

  /** Boolean prop that when is set to true an extra column will be displayed to display the actions - links.
   * If set to true the property actions must be specified */
  hasActions: _propTypes.default.bool,

  /** Array of the desired actions. The callback will be invoked when the corresponding action is clicked.
   * The callback function with have the row datum and row index passed as arguments.
   * If a custom component is defined then the actions wil be rendered according to it. The custom component will
   * also have available the props: datum, action & rowIndex */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired,
    customComponent: _propTypes.default.element,
    isActionLink: _propTypes.default.bool,
    arrowDirection: _propTypes.default.oneOf(['left', 'right']),
    reversedArrow: _propTypes.default.bool
  })),

  /** Boolean indicating if the table should be responsive */
  responsive: _propTypes.default.bool,

  /** Boolean indicating if the rows should be striped */
  striped: _propTypes.default.bool,

  /** Callback invoked  when the use  a row  to change the style of row-  */
  onRowStyleChange: _propTypes.default.func,

  /** Callback invoked on sortable columns click. It will be invoked  with an argument of the column in property.
   * MUST be specified IF column is sortable*/
  onSortedChange: _propTypes.default.func,

  /** String that must match the sortable column id property. MUST be specified IF column is sortable*/
  orderBy: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Boolean indicating if the sort order is ascending or descending */
  orderAsc: _propTypes.default.bool,

  /** object that describes the expandable row table. You can also add all the properties of The Table component
   * in the property nestedTableProps and they will be passed to the nested component. If you want to map-alter the
   * data before display use the dataFormatter function property. It will be called with the data for display. It
   * MUST return the altered data.*/
  expandableRow: _propTypes.default.shape({
    columns: _propTypes.default.arrayOf(_propTypes.default.shape({
      propertyName: _propTypes.default.string.isRequired,
      header: _propTypes.default.string.isRequired,
      formatter: _propTypes.default.func
    })),
    propertyNameWithData: _propTypes.default.string.isRequired,
    dataFormatter: _propTypes.default.func,
    nestedTableProps: _propTypes.default.object,
    nestedTableHeaderVariant: _propTypes.default.string
  }),

  /** The header title of the nested table of each row,
   * The formatter is a callback used to format the header as you wish. */
  sections: _propTypes.default.arrayOf(_propTypes.default.shape({
    propertyName: _propTypes.default.string.isRequired,
    header: _propTypes.default.string.isRequired,
    formatter: _propTypes.default.func
  })),

  /** The header title of the nested table of each row */
  nestedTableTitle: _propTypes.default.string,

  /** flag that indicates that the table should have a table-hover style */
  tableHover: _propTypes.default.bool,

  /** Boolean indicating if the table should be indented */
  isIndented: _propTypes.default.bool,

  /** Custom component to replace the built in nested Table component of each row. It will have the
   * expandable table row passed as a prop */
  customNestedTableComponent: _propTypes.default.element,
  noResultsMessage: _propTypes.default.string,

  /** flag that indicates that the table list is loading*/
  loadingTableList: _propTypes.default.bool,

  /** Changes the header style variant.*/
  headerVariant: _propTypes.default.oneOf(['tertiary']),

  /** String indicating the style to be applied for selected rows */
  selectedRowStyle: _propTypes.default.oneOf([_constants.primaryVariantStyle, _constants.secondaryVariantStyle])
};
var _default = TableList;
exports.default = _default;